'use strict';

var EditNetworkObject = require('actionGroups/editNetworkObject/EditNetworkObject');

module.exports = {
  Model: EditNetworkObject,
};
